import {
  ComponentMapping,
  ContainerProperties,
  MappedComponentProperties,
  Utils,
} from '@adobe/aem-react-editable-components';
import { ComponentType, ReactElement } from 'react';

export type ColumnClassNames = { columnClassNames?: Record<string, string> };

export const getChildComponents = ({
  cqItems,
  cqItemsOrder,
  componentMapping = ComponentMapping,
  isInEditor,
  cqPath,
  columnClassNames,
}: ContainerProperties & ColumnClassNames) => {
  const childComponents: ReactElement[] = [];

  if (!Object.keys(cqItems).length || !cqItemsOrder.length) {
    return childComponents;
  }

  return cqItemsOrder
    .map(itemKey => {
      const itemProps = Utils.modelToProps(cqItems[itemKey]);

      if (!itemProps) {
        return null;
      }

      const className = `${columnClassNames?.[itemKey]} ${itemProps.appliedCssClassNames ?? ''}`;

      const ItemComponent: ComponentType<MappedComponentProperties> = componentMapping.get(itemProps.cqType);

      if (ItemComponent) {
        const itemPath = cqPath ? `${cqPath}/${itemKey}` : itemKey;

        return (
          <ItemComponent
            {...itemProps}
            key={itemPath}
            cqPath={itemPath}
            isInEditor={isInEditor}
            appliedCssClassNames={className}
          />
        );
      }

      return null;
    })
    .filter(Boolean);
};
